import React, {Fragment} from 'react';

import SaveStatus from "../UI/ReactSaveStatus";

export default class TabbedBasePage extends React.Component
{
    constructor(props)
    {
        super(props);

        this.state = {

            activePage: this.props.activePage,
            dirty: false,
            dirtyForms: []
        };

        this.onDirty = this.onDirty.bind(this);
        this.onSaveButtonClick = this.onSaveButtonClick.bind(this);
        this.register = this.register.bind(this);

        this.pages = React.createRef();
        this.pages.current = {};
    }

    register(componentName, componentObject)
    {
        this.pages.current[componentName] = componentObject;
    }

    onDirty(pageId)
    {
        let newTabItems = this.state.tabItems;

        for (let key in this.state.tabItems.items)
        {
            const obj = this.state.tabItems.items[key];

            if (obj.id === pageId)
            {
                newTabItems.items[key].dirty = true;

                break;
            }
        }

        this.setState({dirty: true, tabItems: newTabItems});
    }

    onSaveButtonClick()
    {
        this.lastFormAction();
    }

    setErrorTab(tabName)
    {
        this.setState({activePage: tabName, displayErrors: true});
    }

    setDirty(pageId, value)
    {
        // Clear the green things
        this.setState({dirty: false});
    }

    getComponentData = (component_name) =>
    {
        const registrations = this.pages.current[component_name];

        if (registrations !== undefined)
        {
            if (registrations.getFormData != null && typeof registrations.getFormData === 'function')
            {
                return registrations.getFormData();
            }
        }
        else
        {
            const CurPageobj = this.refs[component_name]

            if (CurPageobj.getFormData != null && typeof CurPageobj.getFormData === 'function')
            {
                // If the page has an onleave function, call it
                return CurPageobj.getFormData();
            }
        }
    }

    componentIsValid = (component_name) =>
    {
        const registrations = this.pages.current[component_name];

        if (registrations !== undefined)
        {
            if (registrations.formIsValid != null && typeof registrations.formIsValid === 'function')
            {
                return registrations.formIsValid();
            }
        }
        else if (this.refs[component_name] !== undefined)
        {
            const CurPageobj = this.refs[component_name]

            if (CurPageobj.formIsValid != null && typeof CurPageobj.formIsValid === 'function')
            {
                // If the page has an onleave function, call it
                return CurPageobj.formIsValid();
            }
        }
        else
        {
            return false;
        }
    }

    triggerAutoSave = (component_name) =>
    {
        const registrations = this.pages.current[component_name];

        if (registrations !== undefined)
        {
            if (registrations.autoSave != null && typeof registrations.autoSave === 'function')
            {
                return registrations.autoSave();
            }
        }
        else if (this.refs[component_name] !== undefined)
        {
            const CurPageobj = this.refs[component_name]

            if (CurPageobj.autoSave != null && typeof CurPageobj.autoSave === 'function')
            {
                // If the page has an onleave function, call it
                return CurPageobj.autoSave();
            }
        }
    }

    triggerOnLeave(activePage)
    {
        const registrations = this.pages.current[activePage];

        if (registrations !== undefined)
        {
            if (registrations.useRef !== undefined && registrations.useRef === true)
            {
                if (this.hasOwnProperty(activePage))
                {
                    const ref = this[activePage].current;

                    ref.onLeave();
                }
            }
            else if (registrations.onLeave != null && typeof registrations.onLeave === 'function')
            {
                registrations.onLeave();
            }
        }
        else if (this.refs[activePage] !== undefined)
        {
            const CurPageobj = this.refs[activePage]

            if (CurPageobj != null && CurPageobj.onLeave != null && typeof CurPageobj.onLeave === 'function')
            {
                // If the page has an onleave function, call it
                CurPageobj.onLeave();
            }
        }
    }

    triggerOnEnter(activePage)
    {
        const registrations = this.pages.current[activePage];

        if (registrations !== undefined)
        {
            if (registrations.useRef !== undefined && registrations.useRef === true)
            {
                if (this.hasOwnProperty(activePage))
                {
                    const ref = this[activePage].current;

                    ref.onEnter();
                }
            }
            else if (registrations.onEnter != null && typeof registrations.onEnter === 'function')
            {
                registrations.onEnter();
            }
        }
        else if (this.refs[activePage] !== undefined)
        {
            const NextPageobj = this.refs[activePage];

            if (NextPageobj != null && NextPageobj.onEnter != null && typeof NextPageobj.onEnter === 'function')
            {
                // If the page we're moving to has an onEnter function, call it
                NextPageobj.onEnter();
            }
        }
    }

    setActivePage(pageId, tabItems, additionalState)
    {
        this.triggerOnLeave(this.state.activePage);

        this.triggerOnEnter(pageId);

        let newState = tabItems == null ? {activePage: pageId} : {activePage: pageId, tabItems: tabItems};

        if (additionalState != null)
        {
            // Merge the state objects together
            newState = {...newState, ...additionalState};
        }

        this.setState(newState);
    }

    getOffsetOfActivePage(pageName)
    {
        var rVal = null;

        for (var key in this.state.tabItems.items)
        {
            var obj = this.state.tabItems.items[key];

            if (obj.id == pageName)
            {
                rVal = key;
                break;
            }
        }

        return rVal;
    }

    getActivePage()
    {
        return this.state.activePage;
    }

    shouldPrevButtonShow(currentTab)
    {
        const curItem = this.getOffsetOfActivePage(currentTab);

        const obj = this.state.tabItems.items[curItem];

        return obj.prev == null ? false : true;
    }

    shouldNextButtonShow(currentTab)
    {
        const curItem = this.getOffsetOfActivePage(currentTab);

        const obj = this.state.tabItems.items[curItem];

        return obj.next == null ? false : true;
    }

    // This function receives references from the child controls so we can reference the child directly
    onNavigate(action)
    {
        var curTabItems = this.state.tabItems;

        var curItem = this.getOffsetOfActivePage(this.getActivePage());

        var lastItem = this.state.tabItems.items.length - 1;

        switch (action)
        {
            case 'next':

                if (curItem < lastItem)
                {
                    curTabItems.items[+curItem + 1].enabled = true;

                    this.setActivePage(curTabItems.items[+curItem + 1].id, curTabItems);
                }
                else
                {
                    this.lastFormAction();
                }

                break;

            case 'prev':

                if (curItem > 0)
                {
                    this.setActivePage(curTabItems.items[+curItem - 1].id, null);
                }

                break;
        }
    }

    tabContent(id, activeFlag)
    {
        return this.tabForm(id, activeFlag);
    }

    tabContentSinglePanel(activeFlag, id, title)
    {
        let c = activeFlag == true ? 'tab-pane in active' : 'tab-pane fade';

        return (
            <div key={'pane' + id} id={id} className={c}>
                <div className={'panel'} style={{'padding': '15px'}}>
                    {this.tabContent(id, activeFlag)}
                </div>
            </div>
        )
    }

    tabContentPanels()
    {
        const activePage = this.state.activePage;

        const showItems = this.getMenuItems().items.filter((item) =>
        {
            return item.show !== false ;
        });

        return showItems.map(row =>
        {
            let activeFlag = activePage === row.id;

            return this.tabContentSinglePanel(activeFlag, row.id);
        });
    }

    tabPanelContainer(stacked)
    {
        if (stacked === true)
        {
            return (
                <div key='panelContainer1' className='col-md-9'>
                    <div className='tab-content'>
                        {this.tabContentPanels()}
                    </div>
                </div>
            )
        }
        else
        {
            return (
                <div key='panelContainer1' className='tab-content'>
                    {this.tabContentPanels()}
                </div>
            )
        }
    }

    ///////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////
    // Code below here builds the tab nav bar
    //////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////////

    tabClick(tabid)
    {
        this.setActivePage(tabid, null);
    }

    decoratedLabel(text, decorator)
    {
        return (
            <Fragment>
                <span key='Decorator1'>{text}</span>
                <span key='Decorator2' className={'glyphicon ' + decorator}
                      style={{color: '#eac02f', marginLeft: '10px'}}/>
            </Fragment>
        )
    }

    hyperlink(enabledFlag, name, titleText, decorator)
    {
        if (enabledFlag === false)
        {
            return <a href={'#' + name}>{this.decoratedLabel(titleText, decorator)}</a>
        }
        else
        {
            return <a data-toggle='tab' onClick={this.tabClick.bind(this, name)}
                      href={'#' + name}>{this.decoratedLabel(titleText, decorator)}</a>
        }
    }

    tabListItem(enabledFlag, active, name, titleText, decorator)
    {
        let classname = active === true ? 'active' : '';

        if (enabledFlag === false)
        {
            classname += classname === '' ? 'disabled' : ' disabled';
        }

        return <li key={'TabListItem' + name} className={classname}>
            {this.hyperlink(enabledFlag, name, titleText, decorator)}
        </li>

    }

    saveStatus()
    {
        return <SaveStatus key='SaveStatus' onClick={this.onSaveButtonClick} dirty={this.state.dirty}/>;
    }

    tabListItems(panelDescription, activePanelId)
    {
        const showItems = panelDescription.items.filter((item) =>
        {
            return item.show !== false ;
        });

        let lineList = showItems.map(row =>
        {
            const activeFlag = activePanelId === row.id;

            return this.tabListItem(row.enabled, activeFlag, row.id, row.title, row.decorator);
        });

        if (this.props.showSaveStatus === true)
        {
            lineList.push(this.saveStatus());
        }

        return lineList;
    }

    /**
     * Generates HTML for the NAV element of the tabbed navigation control.
     *
     * You can also pass 'nav-tabs' or 'nav-pills' to determine how the tabbed control is rendered
     *
     * @param {string} tabType - 'nav-pills' or 'nav-tabs' according to type
     * @return {array}
     */
    tabbedHeaders(tabType, stacked)
    {
        const classname = 'nav' + ' ' + tabType;
        const activePanelId = this.getActivePage();

        if (stacked === true)
        {
            return (
                <Fragment key='theader'>
                    <div key='StackedList' className='col-md-3' style={{'paddingTop': '20px'}}>
                        <ul className={classname}>
                            {this.tabListItems(this.getMenuItems(), activePanelId)}
                        </ul>
                    </div>
                    {this.tabPanelContainer(stacked)}
                </Fragment>
            )
        }
        else
        {
            return (
                <Fragment key='theader'>
                    <ul className={classname}>
                        {this.tabListItems(this.getMenuItems(), activePanelId)}
                    </ul>
                    {this.tabPanelContainer(stacked)}
                </Fragment>
            )
        }
    }
}